module.exports = __webpack_public_path__ + "img/imposta-logo-invoiceweb.38e2a1bc.png";